import { z } from 'zod';
import { baseCustomFieldSchema } from '@/features/dashboard/tourCustomFields/schemas/baseCustomFieldSchema.ts';
import { FieldType } from '@/components/table/_fieldDefinitions/FieldType.ts';

export const longTextCustomFieldSchema = baseCustomFieldSchema.extend({
  type: z.literal(FieldType.LONG_TEXT),
  placeholder: z
    .string()
    .max(255, 'Maksymalna długość placeholdera to 255 znaków'),
  isCharacterLimitEnabled: z.boolean({ error: 'Pole wymagene' }),
  minChars: z
    .int({ error: 'Limit znaków musi być liczbą całkowitą' })
    .nonnegative('Limit znaków musi być większy lub równe 0')
    .optional(),
  maxChars: z
    .int({ error: 'Limit znaków musi być liczbą całkowitą' })
    .positive('Limit znaków musi być większy od 0')
    .optional(),
  isChangeDefaultRowsNumber: z.boolean({ error: 'Pole wymagene' }),
  rowsNumber: z
    .int({ error: 'Liczba wierszy musi być liczbą całkowitą' })
    .positive('Liczba wierszy musi być większa od 0')
    .max(20, 'Liczba wierszy musi być mniejsza lub równa 20')
    .optional(),
});

export type LongTextCustomFieldInputData = z.input<
  typeof longTextCustomFieldSchema
>;
export type LongTextCustomFieldFormData = z.infer<
  typeof longTextCustomFieldSchema
>;
